<template>

    <div id="app">
        <n-config-provider inline-theme-disabled  :theme-overrides="themeOverrides">
            <AppProvider>
                <message-box-example></message-box-example>
                <router-view />
                <Loader></Loader>
                <dialogs-wrapper transition-name="fade"></dialogs-wrapper>
                <dialogs-wrapper name="loading"></dialogs-wrapper>

            </AppProvider>

        </n-config-provider>
    </div>
  
</template>

<script setup>
    import { onMounted, ref } from 'vue';
    import AppProvider from './components/AppProvider';

    const themeOverrides = ref({
        common: {
            primaryColor: '#ABC946FF',
            primaryColorHover: '#BEE638FF',
            primaryColorPressed: '#798E31FF',
        },
        Button: {
            textColor: '#FF0000',
            borderRadius: '8px', 
        },
    });

    onMounted(() => {
        if (window.$core) {
            window.$core.root = {};  
        }
    });


</script>

<style>
</style>

